import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { administrationApi } from '../api/administration.api';

export function useProjets(filtres?: { actif?: boolean }) {
  return useQuery({
    queryKey: ['projets', filtres],
    queryFn: () => administrationApi.listerProjets(filtres),
  });
}

export function useCreerProjet() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: administrationApi.creerProjet,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['projets'] }),
  });
}

export function useDesactiverProjet() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => administrationApi.desactiverProjet(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['projets'] });
      toast.success('Projet désactivé');
    },
    onError: () => toast.error('Erreur lors de la désactivation'),
  });
}

export function useReactiverProjet() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => administrationApi.reactiverProjet(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['projets'] });
      toast.success('Projet réactivé');
    },
    onError: () => toast.error('Erreur lors de la réactivation'),
  });
}

export function useProjet(id: string | undefined) {
  return useQuery({
    queryKey: ['projet', id],
    queryFn: () => administrationApi.obtenirProjet(id!),
    enabled: !!id,
  });
}

export function useAffecterEmploye(idProjet: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: { idEmploye: string; dateDebut: string }) =>
      administrationApi.affecterEmploye(idProjet, data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['projet', idProjet] });
      qc.invalidateQueries({ queryKey: ['projets'] });
    },
  });
}

export function useRetirerEmploye(idProjet: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (idEmploye: string) =>
      administrationApi.retirerEmploye(idProjet, idEmploye),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['projet', idProjet] });
      qc.invalidateQueries({ queryKey: ['projets'] });
    },
  });
}
